import { Component, HostListener } from '@angular/core';
@Component({
  selector: 'cv-admin-games',
  templateUrl: './cv-admin-games.component.html',
  styleUrls: ['./cv-admin-games.component.scss']
})
export class CvAdminGamesComponent {

  
}
